import App from "./app";

export default class FirebaseApp extends App {
    #_appId: String;
    #_apiKey: String;
    #_projectId: String;
    #_senderId: String;
    #_baseURL: String;
    #_vapidKey: String;

    constructor(params = {}) {
        super(params);
        const { fcm } = params;
        this.#_appId = fcm.appId;
        this.#_apiKey = fcm.apiKey;
        this.#_projectId = fcm.projectId;
        this.#_senderId = fcm.senderId;
        this.#_baseURL = fcm.baseURL ?? "./";
        this.#_vapidKey = fcm.vapidKey;
    }

    getAppId() {
        return this.#_appId;
    }

    getApiKey() {
        return this.#_apiKey;
    }

    getProjectId() {
        return this.#_projectId;
    }

    getSenderId() {
        return this.#_senderId;
    }

    getBaseUrl() {
        return this.#_baseURL;
    }

    getVapidKey() {
        return this.#_vapidKey;
    }

    validate() {
        super.validate();
        if (!this.#_appId) {
            throw new Error("appId must be valid");
        }
        if (!this.#_senderId) {
            throw new Error("senderId must be valid");
        }
        if (!this.#_projectId) {
            throw new Error("projectId must be valid");
        }
        if (!this.#_apiKey) {
            throw new Error("apiKey must be valid");
        }
        if (!this.#_vapidKey) {
            throw new Error("vapidKey must be valid");
        }
    }
}
